import React from 'react';
import { GroupsContent } from '../../components/organims/GroupsContent';

export const Groups = () => <GroupsContent />;
